import { render, staticRenderFns } from "./OrganizationProfile.vue?vue&type=template&id=5778d3b2&"
import script from "./OrganizationProfile.vue?vue&type=script&lang=js&"
export * from "./OrganizationProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports